"use strict";
exports.INPUT_MODE_REGEX = /^(<|=|@)?(\??)(\w*)$/;
exports.BINDING_MODE = Object.freeze({
    oneWay: '<',
    twoWay: '=',
    output: '&',
    attr: '@',
    optional: '?'
});
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/February2023-PROD/prima/node_modules/ng-metadata/src/core/directives/binding/constants.js
// module id = 298
// module chunks = 6